module.exports = __webpack_public_path__ + "static/assets/79122b7f414e3e0951834d5d616b9688.otf";